import { axiosInstance } from "./axiosInstance";

const updatePassword = (data) => axiosInstance.post(`change-password`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
});

export { updatePassword }
